import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchFormBaseComponent } from './e5core-ui-search-form-base';

@Component({
  selector: 'e5core-ui-search-form-bootstrap',
  templateUrl: './e5core-ui-search-form-bootstrap.component.html',
  styleUrls: ['./e5core-ui-search-form-bootstrap.component.css']
})
export class E5coreUiSearchFormBootstrapComponent extends E5coreUiSearchFormBaseComponent implements OnInit {

  ngOnInit() {
  }

}
